export const overtimeConstants = {
    // Data loading
    GET_OVERTIME_DATA: "GET_OVERTIME_DATA",
    GET_OVERTIME_DATA_SUCCESS: "GET_OVERTIME_DATA_SUCCESS",
    GET_OVERTIME_DATA_FAILED: "GET_OVERTIME_DATA_FAILED",

    // Employee item collapse
    TOGGLE_ITEM_COLLAPSED: "TOGGLE_ITEM_COLLAPSED",

    // Contact status (answered, notes, phoneNumber)
    SET_CONTACT: "SET_CONTACT",

    // Shift signup decision selection
    SELECT_DECISION: "SELECT_DECISION",

    // Confirm decision
    CONFIRM_DECISION: "CONFIRM_DECISION",
    CONFIRM_DECISION_SUCCESS: "CONFIRM_DECISION_SUCCESS",
    CONFIRM_DECISION_FAILED: "CONFIRM_DECISION_FAILED",

    // Add OT Shift (Assign)
    ADD_OT_SHIFT: "ADD_OT_SHIFT",
    ADD_OT_SHIFT_SUCCESS: "ADD_OT_SHIFT_SUCCESS",
    ADD_OT_SHIFT_FAILED: "ADD_OT_SHIFT_FAILED",

    // Clear signup error
    CLEAR_SIGNUP_ERROR: "CLEAR_SIGNUP_ERROR",

    // Overtime slots (passed from different component)
    SET_OVERTIME_SLOTS: "SET_OVERTIME_SLOTS",

    // Loader
    SHOW_OVERTIME_LOADER: "SHOW_OVERTIME_LOADER",

    // Cleanup
    OVERTIME_CLEANUP: "OVERTIME_CLEANUP",

    // Resolve WB Failed
    RESOLVE_OT_WB_FAILED: "RESOLVE_OT_WB_FAILED",
    RESOLVE_OT_WB_FAILED_SUCCESS: "RESOLVE_OT_WB_FAILED_SUCCESS",
    RESOLVE_OT_WB_FAILED_FAILED: "RESOLVE_OT_WB_FAILED_FAILED",

    GET_OT_SKILLS: "GET_OT_SKILLS",
    GET_OT_SKILLS_DATA: "GET_OT_SKILLS_DATA",
    GET_OT_SKILLS_SUCCESS: "GET_OT_SKILLS_SUCCESS",

    // Slot fulfillment & requirement progression
    SLOT_FULFILLED: "SLOT_FULFILLED",
    RESET_SLOT_FULFILLED: "RESET_SLOT_FULFILLED",
    ADVANCE_TO_NEXT_REQUIREMENT: "ADVANCE_TO_NEXT_REQUIREMENT",

    // VOT Report
    GET_VOT_REPORT: "GET_VOT_REPORT",
    GET_VOT_REPORT_SUCCESS: "GET_VOT_REPORT_SUCCESS",
    GET_VOT_REPORT_FAILED: "GET_VOT_REPORT_FAILED",
    
    // Polling WB status via /addOTShift/status
    POLL_WB_STATUS: "POLL_WB_STATUS",
    POLL_WB_STATUS_SUCCESS: "POLL_WB_STATUS_SUCCESS",

    // Call log
    POST_CALL_LOG: "POST_CALL_LOG",
    POST_CALL_LOG_SUCCESS: "POST_CALL_LOG_SUCCESS",
    POST_CALL_LOG_FAILED: "POST_CALL_LOG_FAILED",
    GET_CALL_LOG: "GET_CALL_LOG",
    IS_CALLED_SUCCESS: "IS_CALLED_SUCCESS",
    GET_CALL_LOG_SUCCESS: "GET_CALL_LOG_SUCCESS",
    GET_CALL_LOG_FAILED: "GET_CALL_LOG_FAILED",

    // Duplicate shift check
    CHECK_DUPLICATE_SHIFT_REQUEST: "CHECK_DUPLICATE_SHIFT_REQUEST",
    CHECK_DUPLICATE_SHIFT_SUCCESS: "CHECK_DUPLICATE_SHIFT_SUCCESS",
    CHECK_DUPLICATE_SHIFT_FAILED: "CHECK_DUPLICATE_SHIFT_FAILED",
    RESET_DUPLICATE_SHIFT_MODAL: "RESET_DUPLICATE_SHIFT_MODAL",

    // OT Signups (assigned shifts from mando/v1/ot/signups)
    GET_OT_SIGNUPS: "GET_OT_SIGNUPS",
    GET_OT_SIGNUPS_SUCCESS: "GET_OT_SIGNUPS_SUCCESS",
    GET_OT_SIGNUPS_FAILED: "GET_OT_SIGNUPS_FAILED",

    // Call log gate: track when a fresh call is needed after decision
    SET_CALL_LOG_GATE: "SET_CALL_LOG_GATE",
    CLEAR_CALL_LOG_GATE: "CLEAR_CALL_LOG_GATE"
};

